import { useEffect, useState } from "react";
import { PuffLoader } from "react-spinners";
import { useNavigate, useSearchParams } from "react-router-dom";
import StartScreen from "../../components/StartScreen";
import AvatarList from "../../components/Menu/avatar-list";

const UniversityHome = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [avatarReady, setAvatarReady] = useState(false);
  const [startSession, setStartSession] = useState(false);
  const [token, setToken] = useState();
  const [language, setLanguage] = useState(localStorage.getItem("language") || "english");
  const [topic, setTopic] = useState(searchParams.get("topic") || "LVTrOE9QY53xJiLqDcmjBk9soxoFGCN5hbtn");
  const [APIConnection, setAPIConnection] = useState(true);
  const [mobileConnection, setMobileConnection] = useState(navigator.onLine);
  const [voiceConnection, setVoiceConnection] = useState(true);
  const [orientation, setOrientation] = useState(window.screen.orientation.type);
  const [device, setDevice] = useState(/Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop");
  const [avatarList, setAvatarList] = useState([]);
  const [activeAvatar, setActiveAvatar] = useState();

  const maxRetryCount = 3;
  const maxDelaySec = 4;
  const updateOrientation = () => {
    // Use window.screen to avoid lint error
    setOrientation(window.screen.orientation.type);
    setDevice(/Mobi|Android|iPhone/i.test(navigator.userAgent) ? "mobile" : "desktop");
  };

  const updateNetworkStatus = () => {
    setMobileConnection(navigator.onLine);
  };

  const fetchWithRetries = async (url, options, retries = 1) => {
    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        setAPIConnection(false);
        throw new Error("API ERROR");
      }
      return response;
    } catch (err) {
      if (retries <= maxRetryCount) {
        const delay = Math.min(Math.pow(2, retries) / 4 + Math.random(), maxDelaySec) * 1000;
        await new Promise((resolve) => setTimeout(resolve, delay));
        console.log(`Request failed, retrying ${retries}/${maxRetryCount}. Error ${err}`);
        return fetchWithRetries(url, options, retries + 1);
      } else {
        setAPIConnection(false);
        throw new Error(`Max retries exceeded. error: ${err}`);
      }
    }
  };

  const login = async () => {
    const loginResponse = await fetchWithRetries(
      `${process.env.REACT_APP_FXAI_SERVER_URL}/api/auth/login`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userName: process.env.REACT_APP_FXAI_AUTH_EMAIL,
          password: process.env.REACT_APP_FXAI_AUTH_PASS,
        }),
      }
    );

    const response = await loginResponse.json();
    if (response.result === "OK") {
      setToken(response.data.authToken);
      setAPIConnection(true);
    } else {
      setAPIConnection(false);
    }
  };

  const pullData = async () => {
    localStorage.setItem("firstVisit", false);
    const avatarResponse = await fetchWithRetries(
      `${process.env.REACT_APP_FXAI_SERVER_URL}/api/config/passphrase/${topic}/language/${language}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    const avatarData = await avatarResponse.json();
    setAvatarList(avatarData.data);
  };

  const handleSelectAvatar = (avatar) => {
    setActiveAvatar(avatar.name);
  };

  const submitAvatar = () => {
    if (activeAvatar) {
      navigate(`${activeAvatar.toLowerCase()}?homepage=true`);
    }
  };

  useEffect(() => {
    updateNetworkStatus();
    login();
  }, []);

  useEffect(() => {
    if (startSession && token) {
      pullData();
    }
  }, [startSession, token]);

  useEffect(() => {
    if (avatarList.length > 0) {
      setAvatarReady(true);
    }
  }, [avatarList]);

  useEffect(() => {
    window.addEventListener("orientationchange", updateOrientation);
    window.addEventListener("resize", updateOrientation);
    window.addEventListener("online", updateNetworkStatus);
    window.addEventListener("offline", updateNetworkStatus);

    return () => {
      window.removeEventListener("orientationchange", updateOrientation);
      window.removeEventListener("resize", updateOrientation);
      window.removeEventListener("online", updateNetworkStatus);
      window.removeEventListener("offline", updateNetworkStatus);
    };
  }, []);

  return (
    <div className="outer-container">
      <div
        className={`container ${
          device !== "desktop" &&
          (orientation === "landscape-primary" || orientation === "landscape-secondary")
            ? "hide"
            : "show"
        }`}
      >
        <div className="connection">
        <div className={`connection-bar ${!mobileConnection ? "bad" : "good"}`}>
          <img src={`${process.env.PUBLIC_URL}/assets/connection.svg`}></img>
          <div className="dot"></div>
        </div>
        <div className={`connection-bar ${!APIConnection ? "bad" : "good"}`}>
          <img src={`${process.env.PUBLIC_URL}/assets/llm.svg`}></img>
          <div className="dot"></div>
        </div>
        <div className={`connection-bar ${!voiceConnection ? "bad" : "good"}`}>
          <img src={`${process.env.PUBLIC_URL}/assets/voice.svg`}></img>
          <div className="dot"></div>
        </div>
       </div>
        <span className="version">v2.5.5</span>
        
        <div className="bottom-logo"><img src={`${process.env.PUBLIC_URL}/assets/logo.png`} /></div>
        {!startSession ? (
          <StartScreen
            language={language}
            handleStartSession={() => setStartSession(true)}
            videoSrc={"../assets/classroom_start.mp4"}
            source={"classroom"}
          />
        ) : (
          <>
            <div className={`loading-container ${avatarReady ? "hide" : ""}`}>
              <PuffLoader color="#fff" size={100} />
              <span className="loading-container_text">
                {language === "english" ? "Preparing the session..." : "Menyiapkan sesi..."}
              </span>
            </div>
            <div className="Menu">
              <div className="menu__header center">
                <div className="menu__title">
                  <p>{language === "english" ? "SELECT AVATAR" : "PILIH AVATAR"}</p>
                </div>
              </div>

              <AvatarList
                avatarList={avatarList}
                handleSelectAvatar={handleSelectAvatar}
                selectedAvatar={activeAvatar}
                handleSubmitAvatar={submitAvatar}
                origin={"classroom"}
              />

              <div className={`menu_avatar-submit ${activeAvatar ? "show" : "hide"}`} onClick={submitAvatar}>
                Submit
              </div>
            </div>
          </>
        )}
      </div>
      <div
        className={`rotate-container ${
          device !== "desktop" &&
          (orientation === "landscape-primary" || orientation === "landscape-secondary")
            ? "show"
            : "hide"
        }`}
      >
        <img className="rotate-img" src="./assets/rotate.png" alt="Rotate" />
      </div>

    </div>
  );
};

export default UniversityHome;
